import * as React from "react";
import LandingNavigation from "./LandingNavigation";
import CutLine from "./CutLine";
import LandingFooter from "./LandingFooter";

export default class LoginLayout extends React.Component<{}, {}> {

    public render(): React.ReactNode {
        return (
            <>
                <LandingNavigation/>
                    <div className="register-box">
                        {this.props.children}
                    </div>
                    <CutLine/>
                <LandingFooter/>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LoginLayout.tsx